import { useMemo } from "react";
import type { FC, PropsWithChildren } from "react";

import { getChildrenRecord } from "../../../../../utils/react";

import type { ButtonSizes } from "../../types";

interface IRightAddon {}

interface IRightAddonMainProps {
    size?: ButtonSizes;
}

const BUTTON_RIGHT_ADDON_DISPLAY_NAME = "Button.RightAddon";

const ButtonRightAddon: FC<IRightAddon> = (props) => {
    const { children, size } = props as PropsWithChildren<
        IRightAddon & IRightAddonMainProps
    >;

    const rightAddonChildren = useMemo(
        () =>
            getChildrenRecord(
                children,
                "Button",
                {
                    Icon: {
                        props: {
                            size,
                            isRight: true,
                        },
                    },
                    IndicatorCounter: {
                        props: {
                            size,
                        },
                    },
                    Unknown: {
                        skipElement: false,
                    },
                },
                { isArrayResult: true },
            ),
        [children, size],
    );

    return rightAddonChildren;
};

ButtonRightAddon.displayName = BUTTON_RIGHT_ADDON_DISPLAY_NAME;

export default ButtonRightAddon;
